module.exports = __webpack_public_path__ + "img/tooth_medal.8e45ad84.svg";